<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item label="组织名称" prop="name" :rules="[{
            required: true,
            message: '请输入组织名称'
          }]">
            <el-input v-model.trim="model.name" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="组织类别" prop="typeId">
            <el-select
              v-model="model.typeId"
              :disabled="!!model.id"
              style="width:100%"
            >
              <el-option
                v-for="orgType in filterOrgTypes"
                :key="orgType.id"
                :value="orgType.id"
                :label="orgType.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model.trim="model.contactName" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="组织邮箱" prop="email">
            <el-input v-model.trim="model.email" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="关联仪器" prop="siteDeviceIds">
        <section class="tree-container border" style="height:300px;">
          <el-tree
            ref="deviceTree"
            :key="treeKey"
            :data="deviceTree"
            :props="{label: 'name'}"
            :show-checkbox="true"
            :check-on-click-node="true"
            node-key="id"
            @check="onDeviceCheckChange"
          />
        </section>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import Drawer from '../../../components/Layout/Drawer'
import {mapGetters} from 'vuex'

export default {
  name: 'OrgEditor',
  extends: BaseEditor,
  components: {Drawer},
  props: {
    orgTypes: {
      required: true,
      type: Array
    },
    sites: {
      required: true,
      type: Array
    },
    siteDevices: {
      required: true,
      type: Array
    },
    list: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      treeKey: 0
    }
  },
  computed: {
    ...mapGetters({
      profileOrgId: 'Profile/orgId'
    }),
    filterOrgTypes () {
      let {orgTypes} = this

      if (this.model.id) {
        return orgTypes
      } else {
        let hasOwner = this.list.some(org => org.typeId === 1)
        return hasOwner ? orgTypes.filter(orgType => orgType.id !== 1) : orgTypes
      }
    },
    siteDeviceMap () {
      return this.siteDevices.reduce((map, siteDevice) => {
        map[siteDevice.id] = siteDevice
        return map
      }, {})
    },
    filterSiteDevices () {
      let {siteDeviceMap, model, profileOrgId} = this
      let {id} = model
      let siteDevices = JSON.parse(JSON.stringify(this.profileSiteDevices))

      if (model.typeId === 2) {
        siteDevices = siteDevices.filter(profileSiteDevice => {
          let siteDevice = siteDeviceMap[profileSiteDevice.id]
          return siteDevice ? (!siteDevice.hasOwnProperty('opsOrgId') || siteDevice.opsOrgId === id) : false
        })
      }

      siteDevices.forEach(siteDevice => {
        siteDevice.disabled = id === profileOrgId
      })

      return siteDevices
    },
    filterSiteDeviceMap () {
      return this.filterSiteDevices.reduce((map, filterSiteDevice) => {
        map[filterSiteDevice.id] = filterSiteDevice
        return map
      }, {})
    },
    deviceTree () {
      let sites = JSON.parse(JSON.stringify(this.profileSites))
      let siteMap = sites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})

      let {model, profileOrgId} = this
      let {id} = model
      let roots = []

      this.filterSiteDevices.forEach(siteDevice => {
        let {siteId} = siteDevice
        let site = siteMap[siteId]

        if (!site) {
          return
        }

        let {children} = site

        if (!Array.isArray(children)) {
          children = site.children = []
          site.disabled = id === profileOrgId
          roots.push(site)
        }

        children.push(siteDevice)
      })

      return roots
    }
  },
  methods: {
    initModel () {
      let model = {
        id: null,
        name: '',
        typeId: null,
        contactName: '',
        email: '',
        siteDeviceIds: []
      }

      setTimeout(() => {
        let {filterOrgTypes} = this

        if (!Array.isArray(filterOrgTypes) || filterOrgTypes.length === 0) {
          return
        }

        this.model.typeId = filterOrgTypes[0].id
      }, 0)

      return model
    },
    onOpen () {
      this.treeKey++
    },
    onDeviceCheckChange () {
      let checkedNodeList = this.getDeviceTree().getCheckedNodes()
      this.model.siteDeviceIds = checkedNodeList.filter(item => !Array.isArray(item.children)).map(item => item.id)
    },
    afterGetDetail (model) {
      let excludeSiteDeviceIds = []
      let {siteDeviceIds} = model

      if (Array.isArray(siteDeviceIds)) {
        let {filterSiteDeviceMap} = this

        excludeSiteDeviceIds = siteDeviceIds.filter(siteDeviceId => !filterSiteDeviceMap[siteDeviceId])

        let refTree = this.getDeviceTree()
        refTree && refTree.setCheckedKeys(siteDeviceIds)
      }

      this.excludeSiteDeviceIds = excludeSiteDeviceIds
    },
    beforeSave () {
      this.model.siteDeviceIds = this.model.siteDeviceIds.concat(this.excludeSiteDeviceIds || [])
    },
    getDeviceTree () {
      return this.$refs.deviceTree
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/02Org/OrgEditor.vue